export const manuelData = [
  {
    "isim": "Karşılaşmalar",
    "platform": "EXXEN",
    "tur": "Dizi",
    "yil": 2025
  },
  {
    "isim": "Anonim",
    "platform": "EXXEN",
    "tur": "Dizi",
    "yil": 2024
  },
  {
    "isim": "İlginç Bazı Olaylar",
    "platform": "EXXEN",
    "tur": "Dizi",
    "yil": 2022
  },
  {
    "isim": "Karma",
    "platform": "EXXEN",
    "tur": "Dizi",
    "yil": 2025
  },
  {
    "isim": "Kara Kenan",
    "platform": "EXXEN",
    "tur": "Dizi",
    "yil": 2025
  },
  {
    "isim": "Nemlizade",
    "platform": "EXXEN",
    "tur": "Dizi",
    "yil": 2023
  },
  {
    "isim": "Leyla ile Mecnun",
    "platform": "EXXEN",
    "tur": "Dizi",
    "yil": 2022
  },
  {
    "isim": "Aşk Kumardır",
    "platform": "EXXEN",
    "tur": "Dizi",
    "yil": 2022
  },
  {
    "isim": "Sadece Arkadaşız",
    "platform": "EXXEN",
    "tur": "Dizi",
    "yil": 2022
  },
  {
    "isim": "Adım Başı Kafe",
    "platform": "EXXEN",
    "tur": "Dizi",
    "yil": 2021
  },
  {
    "isim": "Öğrenci Evi",
    "platform": "EXXEN",
    "tur": "Dizi",
    "yil": 2021
  },
  {
    "isim": "Tertemiz",
    "platform": "EXXEN",
    "tur": "Dizi",
    "yil": 2024
  },
  {
    "isim": "Olağan Şüpheliler",
    "platform": "EXXEN",
    "tur": "Dizi",
    "yil": 2021
  },
  {
    "isim": "Ölüm Zamanı",
    "platform": "EXXEN",
    "tur": "Dizi",
    "yil": 2021
  },
  {
    "isim": "Şeref Bey",
    "platform": "EXXEN",
    "tur": "Dizi",
    "yil": 2021
  },
  {
    "isim": "Hükümsüz",
    "platform": "EXXEN",
    "tur": "Dizi",
    "yil": 2021
  },
  {
    "isim": "Sihirli Annem",
    "platform": "EXXEN",
    "tur": "Dizi",
    "yil": 2021
  },
  {
    "isim": "Sizi Dinliyorum",
    "platform": "EXXEN",
    "tur": "Dizi",
    "yil": 2022
  },
  {
    "isim": "İşte Bu Benim Masalım",
    "platform": "EXXEN",
    "tur": "Dizi",
    "yil": 2021
  },
  {
    "isim": "Yetiş Zeynep",
    "platform": "EXXEN",
    "tur": "Dizi",
    "yil": 2021
  },
  {
    "isim": "Gassal",
    "platform": "Tabii",
    "tur": "Dizi",
    "yil": 2024
  },
  {
    "isim": "Persona",
    "platform": "Tabii",
    "tur": "Dizi",
    "yil": 2025
  },
  {
    "isim": "Siyah Bere",
    "platform": "Tabii",
    "tur": "Dizi",
    "yil": 2025
  },
  {
    "isim": "% İki",
    "platform": "Tabii",
    "tur": "Dizi",
    "yil": 2025
  },
  {
    "isim": "Yankı: İkinci Perde",
    "platform": "Tabii",
    "tur": "Dizi",
    "yil": 2026
  },
  {
    "isim": "Çırak",
    "platform": "Tabii",
    "tur": "Dizi",
    "yil": 2024
  },
  {
    "isim": "Kız Babası",
    "platform": "Tabii",
    "tur": "Dizi",
    "yil": 2025
  },
  {
    "isim": "Rüya Gibi İstanbul",
    "platform": "Tabii",
    "tur": "Dizi",
    "yil": 2025
  },
  {
    "isim": "Rumi",
    "platform": "Tabii",
    "tur": "Dizi",
    "yil": 2023
  },
  {
    "isim": "Marnalı",
    "platform": "Tabii",
    "tur": "Dizi",
    "yil": 2024
  },
  {
    "isim": "Sürgünler",
    "platform": "Tabii",
    "tur": "Dizi",
    "yil": 2025
  },
  {
    "isim": "Derin Mor",
    "platform": "Tabii",
    "tur": "Dizi",
    "yil": 2023
  },
  {
    "isim": "Polis Cemil",
    "platform": "Tabii",
    "tur": "Dizi",
    "yil": 2024
  },
  {
    "isim": "Cihangir Cumhuriyeti",
    "platform": "Tabii",
    "tur": "Dizi",
    "yil": 2025
  },
  {
    "isim": "Son Gün",
    "platform": "Tabii",
    "tur": "Dizi",
    "yil": 2023
  },
  {
    "isim": "Tozkoparan İskender ",
    "platform": "Tabii",
    "tur": "Dizi",
    "yil": 2021
  },
  {
    "isim": "Akif",
    "platform": "Tabii",
    "tur": "Dizi",
    "yil": 2021
  },
  {
    "isim": "Dayton",
    "platform": "Tabii",
    "tur": "Dizi",
    "yil": 2024
  },
  {
    "isim": "Küçük Dahi İbn-i Sina",
    "platform": "Tabii",
    "tur": "Dizi",
    "yil": 2024
  },
  {
    "isim": "Kızılelma ",
    "platform": "Tabii",
    "tur": "Dizi",
    "yil": 2023
  },
  {
    "isim": "Hobbit Beklenmedik Yolculuk",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2012
  },
  {
    "isim": "Aykut Enişte",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2019
  },
  {
    "isim": "John Wick",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2014
  },
  {
    "isim": "Deliler Fatih’in Fermanı",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2023
  },
  {
    "isim": "Sonsuzluğun Kapısında",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2018
  },
  {
    "isim": "Cinayet Süsü",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2019
  },
  {
    "isim": "Parazit",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2019
  },
  {
    "isim": "Oyun Bitti",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2023
  },
  {
    "isim": "Muhteşem Yedili",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2016
  },
  {
    "isim": "Fırıncının Karısı",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2019
  },
  {
    "isim": "IP Man",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2008
  },
  {
    "isim": "Kaptan Fantastik",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2016
  },
  {
    "isim": "Arktik",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2018
  },
  {
    "isim": "İyi Olan Kazansın",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2020
  },
  {
    "isim": "Görevimiz Tatil",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2018
  },
  {
    "isim": "Göçebe",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2017
  },
  {
    "isim": "Kardeşim Benim",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2016
  },
  {
    "isim": "Çağrı",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 1976
  },
  {
    "isim": "Lion",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2016
  },
  {
    "isim": "Büyük Yolculuk",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2004
  },
  {
    "isim": "Hobbit Beş Ordunun Savaşı",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2014
  },
  {
    "isim": "Whiplash",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2014
  },
  {
    "isim": "Odaklan Babaanne",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2020
  },
  {
    "isim": "Pembe Panter",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2006
  },
  {
    "isim": "IP Man 2",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2010
  },
  {
    "isim": "Lessie",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2020
  },
  {
    "isim": "Çöl Aslanı",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 1980
  },
  {
    "isim": "Rocky Balboa",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2006
  },
  {
    "isim": "Pembe Panter 2",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2009
  },
  {
    "isim": "Hobbit Smaug’un Çorak Toprakları",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2013
  },
  {
    "isim": "Gelişmiş Görü",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2023
  },
  {
    "isim": "Cengiz Han",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2007
  },
  {
    "isim": "Alpha Rift",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2021
  },
  {
    "isim": "Ezra",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2023
  },
  {
    "isim": "Güneşin Çocukları",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2020
  },
  {
    "isim": "Birlikte, Yalnız",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2022
  },
  {
    "isim": "Sihirli Ay Işığı",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2014
  },
  {
    "isim": "Creed III",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2023
  },
  {
    "isim": "Patron Seviyesi",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2020
  },
  {
    "isim": "Toprak Uğruna",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2023
  },
  {
    "isim": "Aile Meselesi",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2025
  },
  {
    "isim": "Pinokyo",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2019
  },
  {
    "isim": "Kral İçin Hologram",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2016
  },
  {
    "isim": "Lakewood Hayati Saat",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2021
  },
  {
    "isim": "Yeşil Şövalye",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2021
  },
  {
    "isim": "Rocky 4",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 1985
  },
  {
    "isim": "Detroit",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2017
  },
  {
    "isim": "Hypnotic Zihin Avı",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2023
  },
  {
    "isim": "Eski Toprak",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2024
  },
  {
    "isim": "Till",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2022
  },
  {
    "isim": "Kral Lear",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2018
  },
  {
    "isim": "Balıklara Nasihat",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2022
  },
  {
    "isim": "Şeflerin Aşkı",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2023
  },
  {
    "isim": "Geride Kalanlar",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2023
  },
  {
    "isim": "Cennet Otoyolu",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2022
  },
  {
    "isim": "Spencer",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2021
  },
  {
    "isim": "Gülizar",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2024
  },
  {
    "isim": "Sıfır Kulübü",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2023
  },
  {
    "isim": "Vesper",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2022
  },
  {
    "isim": "Sınıf",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2008
  },
  {
    "isim": "Dağların Kraliçesi",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2014
  },
  {
    "isim": "Bir Tutam Karanfil",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2022
  },
  {
    "isim": "Final Seti",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2020
  },
  {
    "isim": "Lamborghini: Efsanenin Arkasındaki Adam",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2022
  },
  {
    "isim": "Rocky 5",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 1990
  },
  {
    "isim": "Kayıp Şehir Z",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2016
  },
  {
    "isim": "Kahraman",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2021
  },
  {
    "isim": "Rambo Son Kan",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2019
  },
  {
    "isim": "Creed II",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2018
  },
  {
    "isim": "Anafor",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2021
  },
  {
    "isim": "Anılar Çadırı",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2022
  },
  {
    "isim": "Ben Zlatan",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2021
  },
  {
    "isim": "Creed: Efsanenin Doğuşu",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2015
  },
  {
    "isim": "Operasyon Valkyrie",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2008
  },
  {
    "isim": "Rocky 2",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 1979
  },
  {
    "isim": "Büyük Tınılar",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2023
  },
  {
    "isim": "Geliş",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2016
  },
  {
    "isim": "John Wick 2",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2017
  },
  {
    "isim": "John Wick 3",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2019
  },
  {
    "isim": "Yolcu",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 2018
  },
  {
    "isim": "Onbeşliler",
    "platform": "Tabii",
    "tur": "Dizi",
    "yil": 2026
  },
  {
    "isim": "İmam Gazali",
    "platform": "Tabii",
    "tur": "Dizi",
    "yil": 2026
  },
  {
    "isim": "Eyvah Ramazan Bey",
    "platform": "Tabii",
    "tur": "Dizi",
    "yil": 2024
  },
  {
    "isim": "Metamorfoz",
    "platform": "Tabii",
    "tur": "Dizi",
    "yil": 2023
  },
  {
    "isim": "Hür",
    "platform": "Tabii",
    "tur": "Dizi",
    "yil": 2023
  },
  {
    "isim": "Antrenör",
    "platform": "Tabii",
    "tur": "Dizi",
    "yil": 2025
  },
  {
    "isim": "Kapı",
    "platform": "Tabii",
    "tur": "Dizi",
    "yil": 2023
  },
  {
    "isim": "1973 Baltimore Oteli Cinayeti",
    "platform": "Tabii",
    "tur": "Dizi",
    "yil": 2023
  },
  {
    "isim": "Şebeke",
    "platform": "Tabii",
    "tur": "Dizi",
    "yil": 2023
  },
  {
    "isim": "Yardımcı Oyuncu",
    "platform": "Tabii",
    "tur": "Dizi",
    "yil": 2023
  },
  {
    "isim": "Koyu Beyaz",
    "platform": "Tabii",
    "tur": "Dizi",
    "yil": 2023
  },
  {
    "isim": "Mahsusa Trablusgarb",
    "platform": "Tabii",
    "tur": "Dizi",
    "yil": 2023
  },
  {
    "isim": "Şanzelize Düğün Salonu",
    "platform": "Tabii",
    "tur": "Dizi",
    "yil": 2023
  },
  {
    "isim": "Haysultan",
    "platform": "Tabii",
    "tur": "Dizi",
    "yil": 2023
  },
  {
    "isim": "Kuzgun",
    "platform": "Tabii",
    "tur": "Dizi",
    "yil": 2023
  },
  {
    "isim": "Serhat",
    "platform": "Tabii",
    "tur": "Dizi",
    "yil": 2023
  },
  {
    "isim": "Arabesk Rap",
    "platform": "Tabii",
    "tur": "Dizi",
    "yil": 2024
  },
  {
    "isim": "Rocky 3",
    "platform": "Tabii",
    "tur": "Film",
    "yil": 1982
  },
  {
    "isim": "Fer",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2025
  },
  {
    "isim": "Ex Aşkım",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2021
  },
  {
    "isim": "Elçin Sangu 101",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2025
  },
  {
    "isim": "Modern Kadın",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2025
  },
  {
    "isim": "Güller ve Günahlar",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2025
  },
  {
    "isim": "Şahsiyet",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2018
  },
  {
    "isim": "Ru",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2024
  },
  {
    "isim": "Doğu",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2022
  },
  {
    "isim": "Son Kare",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2025
  },
  {
    "isim": "10 Bin Adım",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2021
  },
  {
    "isim": "Daddy Issues",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2024
  },
  {
    "isim": "Operación Marea Negra",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2022
  },
  {
    "isim": "Mahsun J",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2024
  },
  {
    "isim": "Suspect",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2022
  },
  {
    "isim": "Çukur",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2017
  },
  {
    "isim": "Gaipten Gelen Sesler",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2023
  },
  {
    "isim": "Ayak İşleri",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2021
  },
  {
    "isim": "Alice & Jack",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2023
  },
  {
    "isim": "C*A*U*G*H*T",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2023
  },
  {
    "isim": "Bayern Munich Rise Of A Legend",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2023
  },
  {
    "isim": "Gecede Panik",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2023
  },
  {
    "isim": "Burası İngiltere",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2022
  },
  {
    "isim": "Herrhausen: The Banker and The Bomb",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2024
  },
  {
    "isim": "500T",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2021
  },
  {
    "isim": "Dünya Bu",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2023
  },
  {
    "isim": "Esas Oğlan",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2024
  },
  {
    "isim": "#Etkileyici",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2021
  },
  {
    "isim": "Özelden Yürüyenler",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2022
  },
  {
    "isim": "Arjen",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2024
  },
  {
    "isim": "Aslında Özgürsün",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2022
  },
  {
    "isim": "Bizi Ayıran Çizgi",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2021
  },
  {
    "isim": "Cezailer",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2022
  },
  {
    "isim": "Dengeler: Biri Olmak",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2024
  },
  {
    "isim": "Duran",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2022
  },
  {
    "isim": "Hamlet",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2021
  },
  {
    "isim": "\"Kurtuluş\" Lisesi",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2024
  },
  {
    "isim": "Metot",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2021
  },
  {
    "isim": "Senkron",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2022
  },
  {
    "isim": "Gümüş",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2005
  },
  {
    "isim": "Yer Gök Aşk",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2010
  },
  {
    "isim": "Lale Devri",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2010
  },
  {
    "isim": "Hatıran Yeter",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2025
  },
  {
    "isim": "Siyah Beyaz Aşk",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2017
  },
  {
    "isim": "Orta Kafa Aşk",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2021
  },
  {
    "isim": "Cesur ve Güzel",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2016
  },
  {
    "isim": "Kara Sevda",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2015
  },
  {
    "isim": "Yarın Yokmuş Gibi",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2024
  },
  {
    "isim": "Terapist",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2022
  },
  {
    "isim": "Karadayı",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2012
  },
  {
    "isim": "İçerde",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2016
  },
  {
    "isim": "Wreck",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2022
  },
  {
    "isim": "Gaslit",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2022
  },
  {
    "isim": "The Responder",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2021
  },
  {
    "isim": "Ash vs Evil Dead",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2015
  },
  {
    "isim": "Deutschland 83",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2014
  },
  {
    "isim": "Deutschland 86",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2014
  },
  {
    "isim": "Mad Men",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2007
  },
  {
    "isim": "Dicte",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2012
  },
  {
    "isim": "Deutschland 89",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2014
  },
  {
    "isim": "The King",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2021
  },
  {
    "isim": "White Lies",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2022
  },
  {
    "isim": "Elizabeth Taylor: Asi Süperstar",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2023
  },
  {
    "isim": "Ay ve Işıklar",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2018
  },
  {
    "isim": "Prosper",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2024
  },
  {
    "isim": "Actor",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2023
  },
  {
    "isim": "Platform 7",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2023
  },
  {
    "isim": "Sullivan's Crossing",
    "platform": "GAIN",
    "tur": "Dizi",
    "yil": 2023
  },
  {
    "isim": "Karanlık Cinayetler",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2013
  },
  {
    "isim": "Şef Gibi",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2012
  },
  {
    "isim": "Saul’un Oğlu",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2015
  },
  {
    "isim": "After",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2019
  },
  {
    "isim": "Katili Yakalamak",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2023
  },
  {
    "isim": "Bedenimi Kaybettim",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2019
  },
  {
    "isim": "Acı Kahve",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2024
  },
  {
    "isim": "Son Görev",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2020
  },
  {
    "isim": "Balina",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2022
  },
  {
    "isim": "Bekle Beni Sevgilim",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2023
  },
  {
    "isim": "Yang’dan Sonra",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2021
  },
  {
    "isim": "Konsey",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2024
  },
  {
    "isim": "Cehennem Sınırı",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2019
  },
  {
    "isim": "Ormandaki Cadı",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2020
  },
  {
    "isim": "Aşktan Kaçılmaz",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2018
  },
  {
    "isim": "Yuva",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2020
  },
  {
    "isim": "Cennet Koyu",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2020
  },
  {
    "isim": "Şans Tanrıçası",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2019
  },
  {
    "isim": "Spiritwalker",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2021
  },
  {
    "isim": "Judy",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2019
  },
  {
    "isim": "Mavi Yasemin",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2013
  },
  {
    "isim": "Ben, Tonya",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2017
  },
  {
    "isim": "Yaşamın Kıyısında",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2016
  },
  {
    "isim": "Minari",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2020
  },
  {
    "isim": "Yeşil Rehber",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2018
  },
  {
    "isim": "Zoraki Kral",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2010
  },
  {
    "isim": "Göklerin Hakimi",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2004
  },
  {
    "isim": "Her Şey Her Yerde Aynı Anda",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2022
  },
  {
    "isim": "Umut Işığım",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2012
  },
  {
    "isim": "Parazit",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2019
  },
  {
    "isim": "Baba",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2020
  },
  {
    "isim": "Geliş",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2016
  },
  {
    "isim": "İlgi Alanı",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2023
  },
  {
    "isim": "Once",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2006
  },
  {
    "isim": "Ibiza",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2019
  },
  {
    "isim": "İhtiyar Adam ve Silah",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2018
  },
  {
    "isim": "İlgi Manyağı",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2022
  },
  {
    "isim": "Dumplin",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2018
  },
  {
    "isim": "Küçük Serçe",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2022
  },
  {
    "isim": "Büyükbaba Bakıcı",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2020
  },
  {
    "isim": "Elveda Aptallar",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2020
  },
  {
    "isim": "Sevimli Tehlikeli",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2015
  },
  {
    "isim": "Güzel Bir Takım",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2020
  },
  {
    "isim": "Resmi Yarışma",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2022
  },
  {
    "isim": "Bizans Oyunları",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2016
  },
  {
    "isim": "Ali Çevlik",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2022
  },
  {
    "isim": "Tavus Kuşu",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2024
  },
  {
    "isim": "Aşk Bu Mu?",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2018
  },
  {
    "isim": "Deliha",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2014
  },
  {
    "isim": "Provence'ta Yaz",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2014
  },
  {
    "isim": "Belki Evet, Belki Hayır",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2022
  },
  {
    "isim": "Can Dostum",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2011
  },
  {
    "isim": "Drunk Parents",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2019
  },
  {
    "isim": "Suburbicon",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2017
  },
  {
    "isim": "Kitap Kulübü",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2018
  },
  {
    "isim": "Rock’n Roll",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2017
  },
  {
    "isim": "Asteris ve Oburiks: Orta Krallık",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2023
  },
  {
    "isim": "Joy Ride",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2023
  },
  {
    "isim": "İstikamet Düğün",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2017
  },
  {
    "isim": "Mazlum Kuzey",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2015
  },
  {
    "isim": "Yıldızlar Da Kayar",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2022
  },
  {
    "isim": "Aile Arasında",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2017
  },
  {
    "isim": "Özel Bir Hediye",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2022
  },
  {
    "isim": "Elveda",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2019
  },
  {
    "isim": "Dünyanın En Kötü İnsanı",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2021
  },
  {
    "isim": "Aşk Engel Tanımaz",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2020
  },
  {
    "isim": "Ateşten Kalbe Akıldan Dumana",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 1998
  },
  {
    "isim": "Dikkat Bebek Var",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2012
  },
  {
    "isim": "Sessiz Gece",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2021
  },
  {
    "isim": "Garip Bir Aşk Öyküsü",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2008
  },
  {
    "isim": "Red 2",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2013
  },
  {
    "isim": "Başka Yerde",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2019
  },
  {
    "isim": "Bay ve Bayan Smith",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2005
  },
  {
    "isim": "Aylak Takımı",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2021
  },
  {
    "isim": "The Brits Are Coming",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2018
  },
  {
    "isim": "Yol Arkadaşım 2",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2018
  },
  {
    "isim": "Düğün Dernek",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2013
  },
  {
    "isim": "Neşeli Hayat",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2009
  },
  {
    "isim": "Yıldız Haritası",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2014
  },
  {
    "isim": "Mucizeyi Kadınlar Yaratır",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2011
  },
  {
    "isim": "Hükümet Kadın 2",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2013
  },
  {
    "isim": "Aşk ve Dostluk",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2016
  },
  {
    "isim": "Küçük Esnaf",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2018
  },
  {
    "isim": "Tatlım Tatlım",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2017
  },
  {
    "isim": "Berlin Kaplanı",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2012
  },
  {
    "isim": "Hükümet Kadın",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2012
  },
  {
    "isim": "Bayi Toplantısı",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2020
  },
  {
    "isim": "Eyvah Eyvah 3",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2014
  },
  {
    "isim": "Beynelmilel",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2006
  },
  {
    "isim": "Sen Kimsin?",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2012
  },
  {
    "isim": "Eyvah Eyvah 2",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2011
  },
  {
    "isim": "Tebessüm",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2022
  },
  {
    "isim": "Fırıldak Ailesi",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2017
  },
  {
    "isim": "Deli Dumrul",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2017
  },
  {
    "isim": "Öldür Beni Sevgilim",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2019
  },
  {
    "isim": "Sen Kiminle Dans Ediyorsun",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2017
  },
  {
    "isim": "Salur Kazan: Zoraki Kahraman",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2017
  },
  {
    "isim": "Çok Filim Hareketler Bunlar",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2010
  },
  {
    "isim": "Düğüm Salonu",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2018
  },
  {
    "isim": "Hayat Öpücüğü",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2015
  },
  {
    "isim": "Niyazi Gül Dörtnala",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2015
  },
  {
    "isim": "Kocan Kadar Konuş",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2015
  },
  {
    "isim": "Düğün Dernek 2: Sünnet",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2015
  },
  {
    "isim": "Aykut Enişte 2",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2021
  },
  {
    "isim": "Görümce",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2016
  },
  {
    "isim": "Kara Bela",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2015
  },
  {
    "isim": "Deliha 2",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2018
  },
  {
    "isim": "Hokkabaz",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2006
  },
  {
    "isim": "Patron Mutlu Son İstiyor",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2014
  },
  {
    "isim": "Kolonya Cumhuriyeti",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2017
  },
  {
    "isim": "Bir Baba Hindu",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2016
  },
  {
    "isim": "G.O.R.A.",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2004
  },
  {
    "isim": "Dedemin Fişi",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2016
  },
  {
    "isim": "Olanlar Oldu",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2017
  },
  {
    "isim": "Aykut Enişte",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2019
  },
  {
    "isim": "El Değmemiş Aşk",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2016
  },
  {
    "isim": "Kocan Kadar Konuş: Diriliş",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2015
  },
  {
    "isim": "Cebimdeki Yabancı",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2018
  },
  {
    "isim": "Kurtuluş Son Durak",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2012
  },
  {
    "isim": "Vizontele",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2001
  },
  {
    "isim": "Eyvah Eyvah",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2010
  },
  {
    "isim": "Organize İşler Sazan Sarmalı",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2019
  },
  {
    "isim": "Vizontele Tuuba",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2003
  },
  {
    "isim": "Organize İşler",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2005
  },
  {
    "isim": "Yol Arkadaşım",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2017
  },
  {
    "isim": "Bana Masal Anlatma",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2015
  },
  {
    "isim": "Cici Babam",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2018
  },
  {
    "isim": "Aynasız Haluk",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2022
  },
  {
    "isim": "Hedefim Sensin",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2018
  },
  {
    "isim": "Yarın Yokmuş Gibi",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2020
  },
  {
    "isim": "It Came from the Desert",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2017
  },
  {
    "isim": "Biz Böyleyiz",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2019
  },
  {
    "isim": "Her Şey Aşktan",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2016
  },
  {
    "isim": "Rüzgar",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2018
  },
  {
    "isim": "Karışık Kaset",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2014
  },
  {
    "isim": "Amerikan Sapığı",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2000
  },
  {
    "isim": "Bir Rüya İçin Ağıt",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2000
  },
  {
    "isim": "Not: Seni Seviyorum",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2007
  },
  {
    "isim": "Alacakaranlık",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2008
  },
  {
    "isim": "Alacakaranlık Efsanesi: Şafak Vakti 1",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2011
  },
  {
    "isim": "Alacakaranlık Efsanesi: Şafak Vakti 2",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2012
  },
  {
    "isim": "Alacakaranlık Efsanesi: Tutulma",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2010
  },
  {
    "isim": "Alacakaranlık Efsanesi: Yeni Ay",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2009
  },
  {
    "isim": "Aşkın İzi",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2024
  },
  {
    "isim": "3:10 Yuma Treni",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2007
  },
  {
    "isim": "New York Çeteleri",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2002
  },
  {
    "isim": "Sarışın Bomba",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2017
  },
  {
    "isim": "Kurye",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2020
  },
  {
    "isim": "Küçük Bir Rica",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2018
  },
  {
    "isim": "Karabasan",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2005
  },
  {
    "isim": "Pay the Ghost",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2015
  },
  {
    "isim": "Efsane",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2015
  },
  {
    "isim": "Somali Korsanları",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2017
  },
  {
    "isim": "Kelly Çetesi’nin Gerçek Hikayesi",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2019
  },
  {
    "isim": "Şafaktan Önce",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2017
  },
  {
    "isim": "After: Mutluluk",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2022
  },
  {
    "isim": "After: Paramparça",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2020
  },
  {
    "isim": "After: Ayrılık",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2021
  },
  {
    "isim": "After: Her Şey",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2023
  },
  {
    "isim": "Komplo",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2018
  },
  {
    "isim": "Muhteşem Yaratıklar",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2013
  },
  {
    "isim": "Kayıp İllüzyonlar",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2021
  },
  {
    "isim": "Düşler Diyarı",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2012
  },
  {
    "isim": "Foxcatcher Takımı",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2014
  },
  {
    "isim": "Juste La Fin Du Monde",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2016
  },
  {
    "isim": "Kral Lear",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2018
  },
  {
    "isim": "Uyumsuz",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2020
  },
  {
    "isim": "Salinger Yılım",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2020
  },
  {
    "isim": "Mincemeat Operasyonu",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2022
  },
  {
    "isim": "Koku: Bir Katilin Hikayesi",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2006
  },
  {
    "isim": "The Adderall Diaries",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2015
  },
  {
    "isim": "Karanlık Kız",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2021
  },
  {
    "isim": "Yangın Yeri",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2017
  },
  {
    "isim": "Galveston",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2018
  },
  {
    "isim": "Açlık Oyunları",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2012
  },
  {
    "isim": "Açlık Oyunları 2: Ateşi Yakalamak",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2013
  },
  {
    "isim": "Vengeance: A Love Story",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2017
  },
  {
    "isim": "Düzen",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2024
  },
  {
    "isim": "Jackie",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2016
  },
  {
    "isim": "Kolektif",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2019
  },
  {
    "isim": "Neon Şeytan",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2016
  },
  {
    "isim": "Marilyn ile Bir Hafta",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2011
  },
  {
    "isim": "Paramparça",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2017
  },
  {
    "isim": "Soygun",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2017
  },
  {
    "isim": "Prensim",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2015
  },
  {
    "isim": "Rezervuar Köpekleri",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 1992
  },
  {
    "isim": "Mommy",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2014
  },
  {
    "isim": "Ceviz Ağacı",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2020
  },
  {
    "isim": "Gişe Memuru",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2011
  },
  {
    "isim": "Gergedan Mevsimi",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2011
  },
  {
    "isim": "Kefernahum",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2018
  },
  {
    "isim": "Öğretmenler Odası",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2022
  },
  {
    "isim": "Son Gece",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2010
  },
  {
    "isim": "Rumba Terapisi",
    "platform": "GAIN",
    "tur": "Film",
    "yil": 2022
  }
];